import PropTypes from 'prop-types';

export default function ConfirmationType({ confirmationText }) {
  return <div className="modal-confirmation-text">{confirmationText}</div>;
}

ConfirmationType.propTypes = {
  confirmationText: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
};
